<div class="flex flex-col gap-4">
    <!-- Seção: Certificado -->
    <app-card-content [headerColor]="false" icon="pi pi-file-check" title="Certificado">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div class="field">
                <label class="font-semibold block mb-2">Dt. Renovação</label>
                <input pInputText class="w-full" [ngModel]="dtRenovacao" [readonly]="true" />
            </div>
            <div class="field">
                <label class="font-semibold block mb-2">Val. Certificado</label>
                <input pInputText class="w-full" [ngModel]="valCertificado()" [readonly]="true" />
            </div>
        </div>
    </app-card-content>

    <!-- Seção: Controle -->
    <app-card-content [headerColor]="false" icon="pi pi-check-circle" title="Controle">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div class="field">
                <label class="font-semibold block mb-2">Nº Controle</label>
                <input pInputText class="w-full" [ngModel]="controle" [readonly]="true" />
            </div>
            <div class="field">
                <label class="font-semibold block mb-2">Data do Registro</label>
                <input pInputText class="w-full" [ngModel]="dtRegistro" [readonly]="true" />
            </div>
            <div class="field">
                <label class="font-semibold block mb-2">Nº CNES</label>
                <input pInputText class="w-full" [ngModel]="nuCnes" [readonly]="true" />
            </div>
            <div class="field">
                <label for="situacao" class="font-semibold block mb-2">Situação</label>
                <!-- Regular / Pendente / Cancelado -> p-select -->
                <p-select inputId="situacao" [appendTo]="'body'" [options]="situacaoOpts" [(ngModel)]="situacao" optionLabel="label" optionValue="value" placeholder="Selecione" class="w-full" [disabled]="!modoEdicao()"></p-select>
            </div>
        </div>
    </app-card-content>

    <!-- Seção: Registro Sanitário -->
    <app-card-content [headerColor]="false" icon="pi pi-file-check" title="Registro Sanitário">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div class="field">
                <label for="nuRegistroSanitario" class="font-semibold block mb-2">Nº da Licença</label>
                <input id="nuRegistroSanitario" pInputText class="w-full" [(ngModel)]="nuRegistroSanitario" [readonly]="!modoEdicao()" />
            </div>
            <div class="field">
                <label for="tipoLicenca" class="font-semibold block mb-2">Tipo</label>
                <!-- Municipal / Estadual => várias opções -> p-select -->
                <p-select inputId="tipoLicenca" [appendTo]="'body'" [options]="tipoLicencaOpts" [(ngModel)]="tipoLicenca" optionLabel="label" optionValue="value" placeholder="Selecione" class="w-full" [disabled]="!modoEdicao()"></p-select>
            </div>
            <div class="field">
                <label for="dtValidadeRegSanitario" class="font-semibold block mb-2">Data de Validade</label>
                <input id="dtValidadeRegSanitario" pInputText class="w-full" [(ngModel)]="dtValidadeRegSanitario" [readonly]="!modoEdicao()" />
            </div>
        </div>
    </app-card-content>

    <!-- Seção: Alvará de Funcionamento -->
    <app-card-content [headerColor]="false" icon="pi pi-file-edit" title="Alvará de Funcionamento">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div class="field">
                <label for="nuAlvara" class="font-semibold block mb-2">Nº do Alvará</label>
                <input id="nuAlvara" pInputText class="w-full" [(ngModel)]="nuAlvara" [readonly]="!modoEdicao()" />
            </div>
            <div class="field">
                <label for="isento" class="font-semibold block mb-2">Isento</label>
                <!-- Somente Sim/Não -> togglebutton -->
                <app-switch-sim-nao inputId="isento" [(ngModel)]="isento" [desabilitado]="!modoEdicao()" ariaLabel="Isento de alvará" />
            </div>
            <div class="field">
                <label for="dtValidadeAlvara" class="font-semibold block mb-2">Data de Validade</label>
                <input id="dtValidadeAlvara" pInputText class="w-full" [(ngModel)]="dtValidadeAlvara" [readonly]="!modoEdicao()" />
            </div>
        </div>
    </app-card-content>

    <!-- Seção: Outras Informações -->
    <app-card-content [headerColor]="false" icon="pi pi-info-circle" title="Outras Informações">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div class="field">
                <label for="uso" class="font-semibold block mb-2">Uso</label>
                <!-- Exclusivo / Compartilhado -> várias opções -> p-select -->
                <p-select inputId="uso" [appendTo]="'body'" [options]="usoOpts" [(ngModel)]="uso" optionLabel="label" optionValue="value" placeholder="Selecione" class="w-full" [disabled]="!modoEdicao()"></p-select>
            </div>
            <div class="field">
                <label for="especialidade" class="font-semibold block mb-2">Especialidade</label>
                <!-- Somente Sim/Não -> togglebutton -->
                <app-switch-sim-nao inputId="especialidade" [(ngModel)]="especialidade" [desabilitado]="!modoEdicao()" ariaLabel="Consultório especializado" />
            </div>
        </div>
    </app-card-content>

    <!-- Estados -->
    @if (loading()) {
        <div class="mt-2">Carregando dados do consultório...</div>
    }
    @if (!loading() && erro()) {
        <div class="mt-2 text-red-500">{{ erro() }}</div>
    }
</div>
